<template>
	<div>
		<div class="container">
			<h1>Laden</h1>
			<p>Bitte haben Sie einen Moment Geduld, während die Verbindung zum Qualis Server hergestellt wird. Dies kann unter Umständen bis zu 10 Sekunden dauern.</p>
		</div>
		<div class="loader"></div>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
h1 {
	font-size: 2rem;
	margin-bottom: 0.5rem;
}
.container {
	margin: auto;
	padding: 2.5%;
	width: 500px;
	max-width: 80%;
	border: 1px solid black;
	border-radius: 25px;
}

.loader {
	margin: 3rem auto 0 auto;
	border: 10px solid hsl(0, 0%, 95%); /* Light grey */
	border-top: 10px solid rgb(140, 188, 109); /* Blue */
	border-radius: 50%;
	width: 15vw;
	height: 15vw;
	animation: spin 2s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
